"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoCondicional = void 0;
var react_1 = __importStar(require("react"));
var Botao_1 = require("../Botao/Botao");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var estiloBotaoCondicional = require("./BotaoCondicional.module.scss");
var BotaoCondicional = function (_a) {
    var _b = _a.listaCondicoes, listaCondicoes = _b === void 0 ? ["=", "<>", "<=", ">=", "<", ">", "%", "%%", "in", "not_in"] : _b, _c = _a.tamanho, tamanho = _c === void 0 ? "small" : _c, _d = _a.tipo, tipo = _d === void 0 ? "tipoIconSquare" : _d, _e = _a.desabilitado, desabilitado = _e === void 0 ? false : _e, _f = _a.iconeAltura, iconeAltura = _f === void 0 ? "16px" : _f, _g = _a.iconeLargura, iconeLargura = _g === void 0 ? "16px" : _g, _h = _a.icone, icone = _h === void 0 ? "<>" : _h, _j = _a.variante, variante = _j === void 0 ? "outlined" : _j, _k = _a.iconeCor, iconeCor = _k === void 0 ? Cores_1.Cores.GradacaoPrimaria.AzulMU500 : _k, _l = _a.posicaoMenu, posicaoMenu = _l === void 0 ? "bottom" : _l, onClick = _a.onClick, style = _a.style;
    var _m = (0, react_1.useState)(icone), iconeAtual = _m[0], setIconeAtual = _m[1];
    var _o = (0, react_1.useState)(false), abrirMenu = _o[0], setAbrirMenu = _o[1];
    var menuRef = react_1.default.useRef(null);
    (0, react_1.useEffect)(function () {
        var indexIcone = obterIndexInconeAtual(icone);
        setIconeAtual(listaCondicoes[indexIcone]);
    }, [icone]);
    var obterIndexInconeAtual = function (nomeIcone) {
        var index = listaCondicoes.indexOf(nomeIcone);
        return index < 0 ? 0 : index;
    };
    var assignStyleValues = function () {
        var style = {
            backgroundColor: "#f3f3f3",
            display: "flex",
            flexDirection: "column",
            padding: ".25rem",
            position: "absolute",
            gap: ".25rem",
            border: "1px solid #d9d9d9",
            borderRadius: ".5rem",
            zIndex: 15,
            boxShadow: "0px 0px 6px 0px rgba(24, 24, 24, 0.20)",
        };
        switch (posicaoMenu) {
            case "right":
                return __assign(__assign({}, style), { left: "37px", top: "-5px" });
            case "bottom":
                return __assign(__assign({}, style), { left: "-5px", top: "37px" });
            case "top":
                return __assign(__assign({}, style), { left: "-5px", bottom: "37px" });
        }
    };
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setAbrirMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef]);
    return (react_1.default.createElement("div", { className: estiloBotaoCondicional.conteudo, style: style },
        react_1.default.createElement(Botao_1.Botao, { tamanho: tamanho, estilo: variante, desabilitado: desabilitado, tipo: tipo, onClick: function () { return setAbrirMenu(true); } },
            react_1.default.createElement(Icone_1.Icone, { largura: iconeLargura, altura: iconeAltura, cor: desabilitado ? "#d9d9d9" : iconeCor, nome: iconeAtual ? iconeAtual : "=" })),
        listaCondicoes.length > 1 && abrirMenu && (react_1.default.createElement("div", { ref: menuRef, style: assignStyleValues() }, listaCondicoes.map(function (condicao, index) {
            return (react_1.default.createElement(Botao_1.Botao, { key: index, tamanho: tamanho, estilo: condicao === iconeAtual ? "primaryLight" : variante, desabilitado: desabilitado, tipo: tipo, onClick: function () {
                    setIconeAtual(condicao);
                    setAbrirMenu(false);
                    onClick && onClick(condicao);
                } },
                react_1.default.createElement(Icone_1.Icone, { largura: iconeLargura, altura: iconeAltura, cor: desabilitado
                        ? "#d9d9d9"
                        : condicao === iconeAtual
                            ? "#ffffff"
                            : iconeCor, nome: condicao })));
        })))));
};
exports.BotaoCondicional = BotaoCondicional;
